import { render, staticRenderFns } from "./OrderFamilyForm.vue?vue&type=template&id=e84540ee"
import script from "./OrderFamilyForm.vue?vue&type=script&lang=js"
export * from "./OrderFamilyForm.vue?vue&type=script&lang=js"
import style0 from "./OrderFamilyForm.vue?vue&type=style&index=0&id=e84540ee&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports